import React, { useEffect, useState } from "react";
import Navigation from "../navigation/mainNavBar";

import "../footer/Policy.scss";

import Footer from "../footer/Footer";

function MedRP() {
  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="MedRP">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">PORADNIK ODGRYWANIA MEDRP</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          Co zrobić w sytuacji, gdy nerwowy mieszkaniec wymierzy w Nas lufę
          swojego pistoletu i odda kilka celnych strzałów lub wataha wilków
          zatopi w Naszym biednym ciele swoje zębiska?
          <p>
            <u>Odpowiedź jest banalnie prosta!</u>
          </p>
          <p>
            Należy czekać na przyjazd lekarza i wpisać ładny opis obrażeń, które
            dotknęły Waszą postać. Czas oczekiwania na lekarza jest różny w
            zależności od ich ilości na serwerze:
          </p>
          <ul>
            <strong>
              <li>300 sek, gdy nie ma nikogo na dyżurze</li>
              <li>600 sek, gdy lekarze są obecni.</li>
            </strong>
          </ul>
          <p>
            Każdy z Was grając na serwerze wie, jak takowy opis napisać, wszak
            nie dostalibyście inaczej WL’ki. Warto jednak przypomnieć, że{" "}
            <u>lekarzy nie obchodzą okoliczności powstałych ran</u>, tylko to co
            widzą i są w stanie wyczuć w badaniu palpacyjnym:
          </p>
          <ul>
            <li>
              czy rana postrzałowa jest tylko draśnięciem, kula dalej tkwi w
              środku czy przeszła na wylot?
            </li>
            <li>
              jak z krwawieniem rany? czy mamy się martwić i prędko działać, czy
              jednak krwawienie jest umiarkowane?
            </li>
            <li> czy ranę trzeba szyć?</li>
            <li>
              czy doszło do uszkodzeń w obrębie wnętrzności przy postrzale w
              brzuch?
            </li>
            <li> czy żebra są złamane?</li>
          </ul>
          <p>
            To tylko kilka przykładów, wierzymy że widząc je jesteście w stanie
            wykombinować adekwatne obrażenia co do sytuacji. Na kanale
            <strong>#informacje</strong> macie dokładniejszy opis wraz z
            przykładami jak ma to wyglądać.
          </p>
          <p>
            Po przyjeździe lekarza używając on komend <strong>/me</strong> i{" "}
            <strong>/do</strong> będzie opatrywał Waszą postać. Warto bacznie
            śledzić czat, ponieważ czasem lecząc trzeba o coś dopytać a brak
            odpowiedzi z jednej strony często budzi frustracje. Ludzie umierają,
            trzeba ratować, nie ma czasu na afk’i :)
          </p>
          <p>
            <strong>Przykładowo:</strong>
          </p>
          <p>
            Opis pacjenta: Rana postrzałowa lewego barku, kula przeszła na
            wylot, krwawienie umiarkowane.
          </p>
          <p>
            <strong>Lekarz:</strong> /me Rozrywa poszarpaną od postrzału odzież,
            sięga po buteleczkę z alkoholem i zlewa dłonie oraz ranę pacjenta.
            Sięga do torby po gaziki i prędko dociska je do rany z obu stron
            próbując zatamować krwotok.
          </p>
          <p>
            <strong>Lekarz:</strong> /do czy mu się to udało?
          </p>
          <p>
            <strong>Pacjent:</strong> /do tak, krwawienie ustaje/nie, rana
            krwawi dalej lub /try krwawienie ustało (dajecie decydować o tym
            losowi!)
          </p>
          <p>Uznajmy, że doświadczony lekarz opanował krwawienie :)</p>
          <p>
            <strong>Lekarz:</strong> /me Po zatamowaniu krwotoku sięga po nić i
            igłę, zalewa je alkoholem i przystępuje do szycia. (tu lekarz w
            zależności od doświadczenia również może użyć komendy /try i
            sprawdzić czy zakładanie szwów mu się powiodło).
          </p>
          <p>
            Jeśli założenie szwów przebiegło pomyślnie i nie trzeba wykonywać
            kolejnych prób, lekarz przystępuje do dalszych działań.
          </p>
          <p>
            <strong>Lekarz:</strong> /me Oczyszcza ponownie ranę, zakłada
            kompres, a następnie owija ranę bandażem.
          </p>
          <p>
            W zależności od tego czy Wasza postać jest przytomna, czy też nie
            lekarz może użyć soli trzeźwiących by Was obudzić.
          </p>
          <p>
            Po całym zabiegu, jakim jest opatrywanie rany lekarz pomoże Wam się
            podnieść z BW używając odpowiedniego medykamentu.{" "}
            <strong>Pamiętajcie!</strong> To, że zapyta on Was czy dacie radę
            wstać sami czy może jednak potrzebujecie pomocy nie znaczy, że
            wymaga od Was kliknięcia E do samodzielnego zrespienia się.
          </p>
          <p>
            Pomoc medyczna w Hrabstiwe jest płatna, jednak jest to niższa cena w
            przypadku gdy na nogi postawi Was lekarz, a nie skrypt. Lekarz może
            poprosić o zgłoszenie się na wizytę kontrolną. Każde założenie szwów
            jest odnotowywane, więc będziemy wiedzieć czy takowe zdążyły się już
            wrosnąc w ciało czy zostały w porę wyjęte.
          </p>
          <p>
            <strong>
              Uważajcie by przypadkiem nie nacisnąć E. Jeśli tak się stanie od
              razu informujcie na kanale #crash o zaistniałej sytuacji. LUB
              Poproście na czacie OOC o zrespienie po BW i odgrywajcie leżąc
              przy użyciu animacji.
            </strong>
          </p>
          <p>
            Pamiętajcie również, że rany które odniosła Wasza postać mają na nią
            wpływ przez dłuższy czas. Siniaki nawet po posmarowaniu bolą,
            przestrzelona na wylot noga uniemożliwi Wam bieganie przez jakiś
            czas, a złamane żebra wpłyną na komfort poruszania się konno.
          </p>
          <p>
            Jeśli jednak zdarzy się sytuacja, że stan zdrowia Waszej postaci
            będzie sprawiał, że ta chwieje się na nogach i ewidentnie nie czuje
            się najlepiej, jednak nie na tyle by paść jak długa na ziemię
            wówczas również warto zgłosić się do lekarza. W przypadku odgrywania
            RP na RDR’ze <u>niestety nie ma tzw. “uleczki”</u> jednak lekarze na
            pewno pomogą Wam wrócić do pełni zdrowia bądź pokierują jakiego
            medykamentu użyć by to się stało.
          </p>
          <p>
            Oczywiście wszystkie medykamenty, które dostaniecie od lekarza przy
            odgrywaniu są do użycia <strong>OD RAZU</strong>. Czasem zdarzy się,
            że potrzebne będzie użycie opium lub morfiny, by ulżyć Waszej
            postaci. Użycie tego rodzaju medykamentów jest szczególnie
            monitorowane i jeśli oszukacie i zatrzymacie sobie taką buteleczkę
            bądź fiolkę na później możecie spodziewać się bana. Lekarz może
            poprosić Was o wysłanie screena ekranu lub ekwipunku podczas akcji,
            by to sprawdzić.
          </p>
          <p>
            Niektóre medykamenty mogą wpłynąć w konkretny sposób na Waszą
            postać, więc należy odgrywać ich działanie adekwatnie do zażytej
            substancji.
          </p>
          <ul>
            <li>
              <strong>Morfina, opium</strong> - działa przeciwbólowo, wprowadza
              w stan radości i błogości, sprawia że osoba skupia się na
              wewnętrznych przemyśleniach i niekoniecznie ma ochotę na ruch i
              szalone wyprawy w nieznane.
            </li>
            <li>
              <strong>Sole trzeźwiące</strong> - powinny sprawić, że Wasza
              postać odzyska przytomność, mają intensywny oraz bardzo
              nieprzyjemny zapach, to także możecie odegrać.
            </li>
            <li>
              <strong>Lally Cola</strong> - działa pobudzająco, przywraca chęci
              do życia i wypływa pozytywnie na nastrój osoby, która uraczyła się
              tym napojem. Może powodować również drętwienie języka…
            </li>
          </ul>
          <p>
            Poniższa lista przedstawia tylko garstkę medycznych przypadków,
            które możecie odegrać w swoim RP, nie zamyka ona Was w żaden sposób
            na sztampowe odgrywanie! Jako, że naturalną cechą RP jest jego
            nieprzewidywalność, to co spotka Waszą postać pod kątem medycznym
            jest dowolnością, jednak{" "}
            <u>
              wszystko musi być adekwatne do danej sytuacji oraz czasów, w
              których aktualnie odgrywamy tj. 1901r.
            </u>
          </p>
          <ul>
            <li>
              {" "}
              wszelkiego rodzaju przeziębienia - przez katar, po kaszel na
              gorączce kończąc
            </li>
            <li>ból brzucha po spożyciu jedzenia lub nieprzegotowanej wody</li>
            <li>odmrożenia i poparzenia</li>
            <li>wszelkiego rodzaju rany zadane ostrym narzędziem</li>
            <li>złamania</li>
            <li>zwichnięcia</li>
            <li>ból zębów</li>
            <li>problemy ze wzrokiem</li>
            <li>
              {" "}
              problemy z obolałymi plecami lub innymi częściami ciała po całym
              dniu w siodle
            </li>
            <li> zatrucia</li>
            <li>ugryzienie/ukąszenie osy, pszczoły, węża, żółwia…</li>
            <li>
              szczepienia dla profilaktyki - wścieklizna to straszna cholera i
              każdy lekarz Wam o tym powie!
            </li>
            <li>
              rany narządów wewnętrznych - jeśli nie jesteście pewni, lepiej nie
              kombinować bo może się to dla Was źle skończyć
            </li>
            <li>… co Wam jeszcze wpadnie do głów :)</li>
          </ul>
          <p>
            <strong>Mały kruczek na dole:</strong>Lekarze zastrzegają sobie
            prawo do PG. Na mocy nadanej od tych wyżej i regulaminu możemy
            swobodnie wbić ck postaci, która przesadzi z obszernością obrażeń
            bądź te obrażenia będą na tyle wymyślne, że w 1901r. ciężko byłoby
            je opatrzeć w małej mieścinie na Dzikim Zachodzie. Piszcie opisy z
            rozwagą!
          </p>
          <p>
            W razie pytań frakcja lekarzy służy pomocą! Zapraszamy do zadawania
            pytań i rozwiewania wątpliwości - wszak wszyscy jesteśmy tu by robić
            dobry roleplay. Jesteśmy po to by ułatwić Wam odgrywanie medRP, a
            nie zniechęcać do wizyt w lecznicy.
          </p>
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
}

export default MedRP;
